import { render, staticRenderFns } from "./FootprintTable.vue?vue&type=template&id=573ddc3a&scoped=true&"
import script from "./FootprintTable.vue?vue&type=script&lang=js&"
export * from "./FootprintTable.vue?vue&type=script&lang=js&"
import style0 from "./FootprintTable.vue?vue&type=style&index=0&id=573ddc3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ddc3a",
  null
  
)

export default component.exports